import { css } from 'styled-components';
import {
  InnerSection,
  SectionButton,
} from '../../../../../components/Accordion/InnerAccordionSection/styles';
import mediaQuery from '../../../../../helpers/mediaQuery';
import { colors, themeSpecificColors } from '../../../colors';

export default css`
  &${InnerSection} {
    border-top: 1px solid ${colors.neutral04};
    &:first-child {
      border-top: none;
      margin-top: 0;
      padding-top: 0;
    }

    ${mediaQuery.tabletPortrait`
      &:first-child {
        border-top: none;
      }
  `}
  }

  ${SectionButton} {
    color: ${colors.neutral01};

    :hover {
      background-color: ${themeSpecificColors.core01_10};
      outline: solid ${themeSpecificColors.core01_60} 1px;
      outline-offset: -1px;
    }
    :focus-visible {
      border: none;
      background: none;
      box-shadow: 0px 0px 0 4px ${themeSpecificColors.core01_60};
    }
  }
`;
